<div class="dialog-content">
  <form class="k-form" [formGroup]="taskForm">
    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="taskName" text="Aufgabe"></kendo-label>
      <kendo-textbox [formControlName]="formControlNames.TaskName" #taskName> </kendo-textbox>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start"
        [for]="userDropdown"
        text="Zugewiesen"
      ></kendo-label>
      <kendo-dropdownlist
        [data]="users"
        textField="username"
        valueField="id"
        [formControlName]="formControlNames.Assignee"
        #userDropdown
      >
        <ng-template kendoDropDownListItemTemplate kendoDropDownListValueTemplate let-user>
          <div class="k-d-inline-flex k-align-items-center">
            <app-shive-avatar [user]="user"></app-shive-avatar>
            <div class="member-name k-ml-3">{{ user | memberName }}</div>
          </div>
        </ng-template>
      </kendo-dropdownlist>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="status" text="Status"></kendo-label>
      <kendo-dropdownlist
        textField="text"
        valueField="value"
        [data]="statusDropdownOptions"
        [formControlName]="formControlNames.Status"
        #status
      >
      </kendo-dropdownlist>
    </kendo-formfield>

    <div
      class="k-d-grid k-align-items-center"
      style="
        grid-template-columns: minmax(117px, max-content) auto;
        margin-bottom: 1.5rem;
        height: 40px;
      "
    >
      <kendo-label text="Verrechenbar" [for]="billable"></kendo-label>
      <div class="k-form-field-checkbox-wrap">
        <input
          #billable
          type="checkbox"
          kendoCheckBox
          [formControlName]="formControlNames.Billable"
        />
      </div>
    </div>

    @if (showHourlyExpenditureRateFormField()) {
      <div
        class="k-d-grid"
        style="grid-template-columns: minmax(115px, max-content) auto; margin-bottom: 1.5rem"
      >
        <kendo-label class="!k-align-items-start" [text]="'Stundensatz'"></kendo-label>
        <div class="k-d-flex">
          <span class="prefix-currency">&euro;</span>
          {{ rateAndBudget()[0] }}
          <fa-icon
            class="edit turquoise icon-button k-display-flex k-align-items-stretch k-ml-3.5 fa-md"
            role="button"
            (click)="
              projectTaskGridService.openNewExpenditureRateDialog(taskGridRow(), makeApplyResult)
            "
            [icon]="faPenToSquare"
          ></fa-icon>
        </div>
      </div>
    }

    @if (showBudgetMonetaryPerTaskFormField()) {
      <kendo-formfield orientation="horizontal">
        <kendo-label
          class="!k-align-items-start"
          [for]="budgetPerTask"
          [text]="'Budget'"
        ></kendo-label>
        <div class="k-d-flex">
          <span class="prefix-currency">&euro;</span>
          <kendo-numerictextbox
            [formControlName]="formControlNames.BudgetPerTask"
            #budgetPerTask
            [spinners]="false"
            format="m2"
            [value]="rateAndBudget()[1]"
          >
          </kendo-numerictextbox>
        </div>
      </kendo-formfield>
    }

    @if (showBudgetHoursPerTaskFormField()) {
      <kendo-formfield orientation="horizontal">
        <kendo-label
          class="!k-align-items-start"
          [for]="hoursPerTask"
          [text]="'Budget'"
        ></kendo-label>
        <div class="k-d-flex">
          <kendo-timepicker
            [formControlName]="formControlNames.HoursPerTask"
            #hoursPerTask
            [format]="'HH:mm'"
          >
          </kendo-timepicker>
        </div>
      </kendo-formfield>
    }
  </form>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton (click)="submit()" class="!k-pr-4" themeColor="base" size="large">
    @if (userOperation() === UserOperation.Create) {
      <fa-icon class="add k-text-white k-mr-3" [icon]="faCirclePlus"></fa-icon>
      <span class="label">Hinzufügen</span>
    }

    @if (userOperation() === UserOperation.Update) {
      <fa-icon class="update k-text-white k-mr-3" [icon]="faPenToSquare"></fa-icon>
      <span class="label">Aktualisieren</span>
    }

    @if (userOperation() === UserOperation.Delete) {
      <span class="remove custom-symbol k-mr-3"></span>
      <span class="label">Löschen</span>
    }
  </button>
</footer>
